export default __webpack_public_path__ + "media/event-heroImg.2cfc434a.png";